import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Clock } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      for (let i = 0; i < 30 && !cancelled; i++) {
        try {
          const { data } = await api.get(`/payments/status/${sid}`);
          if (data.payment_status === "paid") { setStatus("paid"); return; }
          if (data.status === "expired" || data.status === "failed") { setStatus("failed"); return; }
        } catch {}
        setAttempts(i + 1);
        await new Promise((r) => setTimeout(r, 2000));
      }
      if (!cancelled) setStatus("timeout");
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 grid-bg">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="flex justify-center mb-6"><Logo size={48} /></div>
        {status === "checking" && <><Clock size={64} weight="duotone" className="mx-auto text-blue-600" />
          <h2 className="text-2xl font-extrabold mt-4" style={{ fontFamily: "Manrope" }}>Confirmando pagamento…</h2>
          <p className="text-muted-foreground mt-2 text-sm">Tentativa {attempts}/30</p></>}
        {status === "paid" && <><CheckCircle size={64} weight="fill" className="mx-auto text-emerald-600" />
          <h2 className="text-2xl font-extrabold mt-4" style={{ fontFamily: "Manrope" }}>Assinatura ativa!</h2>
          <p className="text-muted-foreground mt-2">Obrigado! Sua conta está liberada.</p>
          <Link to="/empresa"><Button data-testid="btn-back-dashboard" className="mt-6 bg-blue-600 hover:bg-blue-700 hover:text-white text-white">Ir para o painel</Button></Link></>}
        {(status === "failed" || status === "timeout" || status === "error") && <><XCircle size={64} weight="fill" className="mx-auto text-red-600" />
          <h2 className="text-2xl font-extrabold mt-4" style={{ fontFamily: "Manrope" }}>Não foi possível confirmar</h2>
          <p className="text-muted-foreground mt-2 text-sm">Tente novamente ou entre em contato.</p>
          <Link to="/empresa"><Button variant="outline" className="mt-6">Voltar</Button></Link></>}
      </Card>
    </div>
  );
}
